<script>
    import moment from 'moment'

    export default {
        props: {
            item: {
                type: Object,
                required: true
            },
            format: {
                type: String,
                default: () => 'D MMM, YYYY'
            }
        },
        render (createElement) {
            if (!this.item.starts_at && !this.item.ends_at) {
                return this._v('None set')
            }

            const startsAt = moment(this.item.starts_at).format(this.format)
            const endsAt = this.item.ends_at
                ? ' - ' + moment(this.item.ends_at).format(this.format)
                : '+'

            // @see https://stackoverflow.com/a/42427127
            return this._v(`${startsAt}${endsAt}`)
        }
    }
</script>
